import { InjectionToken } from '@angular/core';

import { GeoCoordinatorClientConfig } from '@frontend/geo-coordinator/client-models';

export const GEO_COORDINATOR_CONFIG_TOKEN = new InjectionToken<GeoCoordinatorClientConfig>('GeoCoordinator Config Token');
export const GEO_COORDINATOR_CONFIG_PROVIDER_TOKEN = new InjectionToken<GeoCoordinatorConfigProvider>('GeoCoordinator Config Provider Token');

export interface GeoCoordinatorConfigProvider {
    provide(): GeoCoordinatorClientConfig;
}
